import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';

import { getRegions, globalConst } from '..';

export function useGetRegions(props?: { isNotAll?: boolean }) {
  const t = useTranslations();

  const { data: regions, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_ALL_REGION],
    queryFn: getRegions,
    select: regions =>
      props?.isNotAll
        ? regions
        : [
            {
              value: 0,
              label: t('barcha_regionlar')
            },
            ...(regions || [])
          ]
  });

  return { regions, ...args };
}
